import type {
  FineUploaderUpload,
  StudentEditSubmissionDeleteWorkExperienceRequest,
  WorkExperienceEditPayload,
} from './api'

export type WorkExperienceModalFormState = {
  currentWorkExperience: Partial<WorkExperienceEditPayload>
  workExperienceYear: string
  workExperienceShortDescription: string
  workExperienceLongDescription: string
  workExperienceConfirmCloseWithoutSave: boolean
}

export const workExperienceCloseWithoutSavingMessage = 'Close without saving?'
export const workExperienceDeleteConfirmationMessage = 'Are you sure you want to remove this work experience?'

export function newWorkExperienceModalState(): Partial<WorkExperienceEditPayload> {
  return {
    experience_short_description: '',
    experience_long_description: '',
    experience_year: '',
    subject_request_list: [],
  }
}

export function initialWorkExperienceModalFormState(
  workExperience: Partial<WorkExperienceEditPayload>,
): WorkExperienceModalFormState {
  return {
    currentWorkExperience: workExperience,
    workExperienceYear: workExperience.experience_year == null ? '' : String(workExperience.experience_year),
    workExperienceShortDescription: workExperience.experience_short_description ?? '',
    workExperienceLongDescription: workExperience.experience_long_description ?? '',
    workExperienceConfirmCloseWithoutSave: false,
  }
}

export function buildWorkExperienceEditPayload(args: {
  existingWorkExperience: Partial<WorkExperienceEditPayload>
  workExperienceYear: string
  workExperienceShortDescription: string
  workExperienceLongDescription: string
  deleteAttachmentIds: number[]
  newAttachments: FineUploaderUpload[]
}): WorkExperienceEditPayload {
  return {
    ...args.existingWorkExperience,
    experience_year: args.workExperienceYear,
    experience_short_description: args.workExperienceShortDescription,
    experience_long_description: args.workExperienceLongDescription,
    subject_request_list: args.existingWorkExperience.subject_request_list ?? [],
    delete_attachments: args.deleteAttachmentIds,
    new_attachments: args.newAttachments,
  }
}

export function buildWorkExperienceDeleteRequest(
  secureData: string,
  submissionWorkExperienceId: number,
): StudentEditSubmissionDeleteWorkExperienceRequest {
  return {
    secure_data: secureData,
    delete_work_experience_id: submissionWorkExperienceId,
  }
}
